import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { TranslationValues } from 'next-intl';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface TermProps {
  readonly index: string;
  readonly term?: MessageKey;
  readonly content: MessageKey;
  readonly values?: TranslationValues;
  readonly isDefinition?: boolean;
}

const Term = ({
  index,
  term,
  content,
  values,
  isDefinition,
}: TermProps): JSX.Element => {
  const t = useTranslations();
  return (
    <TypographyV3
      className={cx('relative pl-14', {
        'my-0': isDefinition,
      })}
    >
      <span className="absolute left-0">{index}.</span>
      {term ? (
        <>
          <u>{t(term)}</u>
          {`. `}
        </>
      ) : null}
      {t.rich(content, values)}
    </TypographyV3>
  );
};

export default Term;
